<template>
    <Column title="Then">
    	<div style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
	        <FlowCard v-for="(card, index) in cards" :key="card.uri+card.id+index" :card="card" type="action"></FlowCard>
        </div>
    </Column>
</template>

<script>
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import Column from '../../Column/index.vue';
    import FlowCard from '../FlowCard/index.vue';

    @Component({
        components: {
            Column,
            FlowCard
        },
    })
    export default class ActionEditor extends Vue {
        @Prop({ type: Array, default: () => [] }) cards;
        @Prop({ type: String }) type;

        get hasHeader() {
            return Boolean(this.$slots.header);
        }

    }
</script>

<style lang="scss">

</style>